export default {
    事由区分コード: '事由区分コード',
    事由区分名称: '事由区分名称',
    事由区分略称: '事由区分略称',
    項目: '項目',
    時間数: '時間数',
    計算処理: '計算処理',
    ワークフローへ追加: 'ワークフローへ追加'
};
